import { Text as UIText } from "@gluestack-ui/themed";
import { TextProps } from "./types";
import { getFontFamilyProps } from "./utils";

export const Text = ({ children, family, fontWeight, ...props }: TextProps) => {
  const fontFamilyProps = getFontFamilyProps(family, fontWeight as number);
  return (
    <UIText {...props} {...fontFamilyProps}>
      {children}
    </UIText>
  );
};
